import styled, { css } from 'styled-components';

import { FlexDiv, GenericDiv, GenericP } from '../../../../common/Styles';

export const FaqWrapper = styled(GenericDiv).attrs((props) => ({
	itemscope: props.itemScope,
	itemtype: props.itemType
}))(
	({ theme: { down, breakpoints } }) => `
		position: relative;
		background: #fff;
		h2, h4 {
			text-align: center;
		}
		${down(breakpoints.md)} {
		}
  `
);

export const FaqItemWrap = styled(GenericDiv).attrs((props) => ({
	itemscope: props.itemScope,
	itemtype: props.itemType,
	itemprop: props.itemProp
}))(
	({ theme: { down, breakpoints } }) => `
		border-bottom: 2px solid #EEEEEE;
		padding: 14px 0;
		ul {
			padding-left: 10px;
		}
		li {
			margin-top: 10px;
			margin-left: 15px;
			list-style: disc;
		}
		${down(breakpoints.md)} {
		}
  `
);

export const FaqTitle = styled(FlexDiv)(
	({ active, theme: { down, breakpoints } }) => `
		font-size: 20px;
		cursor: pointer;
		${active && `
			color: #ff664b;
			font-weight: bold;
		`}
  `
);

export const FaqArrow = styled.span(
	({ active, theme: { down, breakpoints } }) => `
	position: relative;
	background: #F7F7F7;
	width: 22px;
	height: 22px;
	min-width: 22px;
	min-height: 22px;
	border-radius: 50%;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	&::before {
		border: solid #000;
		border-width: 0 2px 2px 0;
		display: inline-block;
		padding: 2.5px;
		transform: rotate(45deg);
		position: relative;
		right: 0;
		top: 0px;
		content: "";
	}
	${active && `
		&::before {
			border-color: #F76162;
			transform: rotate(-130deg);
		}
	`}
  `
);

export const FaqDesc = styled(GenericDiv)(
	({ theme: { down, breakpoints } }) => `
		position: relative;
		background: #fff;
		${down(breakpoints.md)} {
		}
  `
);

export const FaqAns = styled(GenericDiv).attrs((props) => ({
	itemscope: props.itemScope,
	itemtype: props.itemType,
	itemprop: props.itemProp
}))`
	${(props) => !props.active && css`
        height: 0;
				overflow: hidden;
				opacity: 0;
				margin: 0;
				padding: 0;
        width: 0;`}
`;
